import { render, staticRenderFns } from "./modalEditTeamCompetition.vue?vue&type=template&id=b5c4ff22&"
import script from "./modalEditTeamCompetition.vue?vue&type=script&lang=js&"
export * from "./modalEditTeamCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports